(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-crecs]');
    if (!el) return;
    var section = el.closest('.shopify-section');
    if (!el.dataset.url) { if (section) section.style.display = 'none'; return; }
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-crecs]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else if (section) section.style.display = 'none';
      })
      .catch(function () { if (section) section.style.display = 'none'; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    /* Compact header once the page has scrolled. Shrinking the header moves the
       page up by about 28px and the browser shifts the scroll position to match,
       so a single threshold flips back and forth near the top (the header
       "quivers"). Two thresholds further apart than that shift stop the loop:
       compact past 64px, full size again only above 8px. */
    var ticking = false;
    var compact = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (!compact && y > 64) compact = true;
        else if (compact && y < 8) compact = false;
        header.classList.toggle('is-scrolled', compact);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* All department dropdowns the same height: measure each panel's natural
       height once (panels are display:none until opened), keep the tallest */
    function equaliseMega() {
      var panels = header.querySelectorAll('.hdr__mega');
      if (!panels.length) return;
      header.style.removeProperty('--mega-h');
      if (window.matchMedia('(max-width: 61.99em)').matches) return;
      var max = 0;
      panels.forEach(function (p) {
        var inner = p.querySelector('.hdr__megain');
        if (!inner) return;
        var was = p.getAttribute('style') || '';
        p.setAttribute('style', was + ';display:block !important;visibility:hidden;pointer-events:none;animation:none');
        max = Math.max(max, inner.getBoundingClientRect().height);
        p.setAttribute('style', was);
      });
      if (max > 0) header.style.setProperty('--mega-h', Math.ceil(max) + 'px');
    }
    equaliseMega();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(equaliseMega);
    window.addEventListener('load', equaliseMega);
    var eqTimer;
    window.addEventListener('resize', function () { clearTimeout(eqTimer); eqTimer = setTimeout(equaliseMega, 200); });

    /* Department dropdowns: the first tap opens on touch screens; hover is CSS */
    var cats = header.querySelector('[data-cats]');
    function closePanels(except) {
      header.querySelectorAll('.hdr__catitem.is-open').forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var a = li.querySelector('[data-cat-toggle]');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
    }
    if (cats) {
      cats.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-cat-toggle]');
        if (!toggle) return;
        var li = toggle.closest('.hdr__catitem');
        if (!li.classList.contains('is-open') && window.matchMedia('(hover: none)').matches) {
          e.preventDefault();
          closePanels(li);
          li.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
      document.addEventListener('click', function (e) {
        if (!cats.contains(e.target)) closePanels();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePanels();
      });
    }

    /* Drawer menu */
    var drawer = document.querySelector('[data-menu-drawer]');
    var burger = header.querySelector('[data-menu-toggle]');
    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('has-drawer');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      var panel = drawer.querySelector('[data-menu-panel]');
      if (panel) panel.focus({ preventScroll: true });
    }
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('has-drawer');
      if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus({ preventScroll: true }); }
    }
    if (burger) burger.addEventListener('click', function () {
      drawer && drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-close]')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    /* Phone search row */
    var stoggle = header.querySelector('[data-search-toggle]');
    var srow = document.getElementById('hdr-mobile-search');
    if (stoggle && srow) {
      stoggle.addEventListener('click', function () {
        var open = !srow.hidden;
        srow.hidden = open;
        stoggle.setAttribute('aria-expanded', String(!open));
        if (!open) {
          var f = srow.querySelector('[data-search-field]');
          if (f) requestAnimationFrame(function () { f.focus(); });
        }
      });
    }

    /* Autosuggest: products only, rendered server-side by sections/predictive-search */
    var SUGGEST = '/search/suggest?section_id=predictive-search&resources[type]=product&resources[limit]=6&q=';
    document.querySelectorAll('[data-search]').forEach(function (form) {
      var field = form.querySelector('[data-search-field]');
      var results = form.querySelector('[data-search-results]');
      if (!field || !results) return;
      var ctrl, timer;

      function clear() { results.innerHTML = ''; results.hidden = true; }
      function items() { return Array.from(results.querySelectorAll('[data-psearch-item]')); }
      function move(dir) {
        var list = items();
        if (!list.length) return;
        var i = list.findIndex(function (el) { return el.classList.contains('is-active'); });
        list.forEach(function (el) { el.classList.remove('is-active'); });
        i = i === -1 ? (dir > 0 ? 0 : list.length - 1) : (i + dir + list.length) % list.length;
        list[i].classList.add('is-active');
        list[i].scrollIntoView({ block: 'nearest' });
      }
      function suggest(q) {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        fetch(SUGGEST + encodeURIComponent(q), { signal: ctrl.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var inner = tmp.querySelector('[data-psearch]');
            results.innerHTML = inner ? inner.innerHTML : '';
            results.hidden = !results.innerHTML.trim();
          })
          .catch(function (err) { if (err.name !== 'AbortError') clear(); });
      }

      field.addEventListener('input', function () {
        var q = field.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { clear(); return; }
        timer = setTimeout(function () { suggest(q); }, 180);
      });
      field.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
        else if (e.key === 'Escape') { clear(); }
        else if (e.key === 'Enter') {
          var active = results.querySelector('[data-psearch-item].is-active');
          if (active) { e.preventDefault(); window.location.href = active.href; }
        }
      });
      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) clear();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var holders = document.querySelectorAll('[data-hero-video]');
    if (!holders.length) return;
    function start() {
      holders.forEach(function (el) {
        if (el.dataset.started) return;
        var phone = window.matchMedia('(max-width: 47.99em)').matches;
        var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var saving = navigator.connection && navigator.connection.saveData;
        if ((phone && !('phones' in el.dataset)) || calm || saving) return;
        el.dataset.started = '1';
        var kind = el.dataset.kind, src = el.dataset.src;
        var show = function () { el.classList.add('is-playing'); };
        if (kind === 'mp4') {
          var vd = document.createElement('video');
          vd.muted = true; vd.loop = true; vd.autoplay = true; vd.playsInline = true; vd.preload = 'auto';
          vd.setAttribute('muted', ''); vd.setAttribute('playsinline', '');
          vd.addEventListener('playing', show, { once: true });
          vd.src = src;
          el.appendChild(vd);
          var p = vd.play(); if (p && p.catch) p.catch(function () {});
          return;
        }
        if (kind === 'vimeo') {
          /* Vimeo's player script says when the video is really playing */
          var go = function () {
            try {
              var player = new window.Vimeo.Player(el, { id: Number(src), autoplay: true, muted: true, loop: true, autopause: false, dnt: true, title: false, byline: false, portrait: false });
              player.on('playing', show);
              player.ready().then(function () {
                var f = el.querySelector('iframe');
                if (f) { f.setAttribute('tabindex', '-1'); f.title = 'Background video'; }
              }).catch(function () {});
            } catch (x) { /* photo stays */ }
          };
          if (window.Vimeo && window.Vimeo.Player) go();
          else {
            var sc = document.createElement('script');
            sc.src = 'https://player.vimeo.com/api/player.js';
            sc.async = true;
            sc.onload = go;
            document.head.appendChild(sc);
          }
          return;
        }
        var fr = document.createElement('iframe');
        fr.src = src;
        fr.title = 'Background video';
        fr.setAttribute('tabindex', '-1');
        fr.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
        fr.addEventListener('load', function () { setTimeout(show, 1500); });
        el.appendChild(fr);
      });
    }
    /* Only once everything else has loaded, so the page itself is never slower */
    if (document.readyState === 'complete') setTimeout(start, 300);
    else window.addEventListener('load', function () { setTimeout(start, 300); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Filters and sorting refresh the results in place (Section Rendering API);
     the form still works as a plain GET without JavaScript. */
  (function () {
    var root = document.querySelector('[data-results-root]');
    if (!root) return;
    var sectionId = root.closest('.shopify-section') && root.closest('.shopify-section').id.replace('shopify-section-', '');
    var timer, ctrl;

    function form() { return root.querySelector('[data-filter-form]'); }

    function buildUrl(extra) {
      var f = form();
      var params = new URLSearchParams(f ? new FormData(f) : undefined);
      Array.from(params.keys()).forEach(function (k) {
        if (k.indexOf('filter.v.price') === 0 && params.get(k) === '') params.delete(k);
      });
      if (extra) Object.keys(extra).forEach(function (k) { params.set(k, extra[k]); });
      var base = f ? f.getAttribute('action') : window.location.pathname;
      var qs = params.toString();
      return base + (qs ? '?' + qs : '');
    }

    function load(url, push) {
      if (!sectionId) { window.location.href = url; return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      root.classList.add('is-loading');
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { signal: ctrl.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-results-root]');
          if (!fresh) { window.location.href = url; return; }
          ['[data-results]', '[data-filters]', '[data-results-count]'].forEach(function (sel) {
            var a = root.querySelector(sel), b = fresh.querySelector(sel);
            if (a && b) a.innerHTML = b.innerHTML;
          });
          if (push) window.history.pushState({ url: url }, '', url);
          root.classList.remove('is-loading');
          var top = root.getBoundingClientRect().top + window.scrollY - 120;
          if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
        })
        .catch(function (err) { if (err.name !== 'AbortError') window.location.href = url; });
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-filter-form]')) {
        clearTimeout(timer);
        timer = setTimeout(function () { load(buildUrl(), true); }, e.target.type === 'number' ? 600 : 120);
      } else if (e.target.matches('[data-sort-select]')) {
        var mirror = root.querySelector('[data-sort-mirror]');
        if (mirror) mirror.value = e.target.value;
        load(buildUrl({ sort_by: e.target.value }), true);
      }
    });

    root.addEventListener('submit', function (e) {
      if (!e.target.closest('[data-filter-form]')) return;
      e.preventDefault();
      load(buildUrl(), true);
      closeFilters();
    });

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-filter-link], .pager a');
      if (!link) return;
      e.preventDefault();
      load(link.getAttribute('href'), true);
    });

    window.addEventListener('popstate', function () {
      load(window.location.pathname + window.location.search, false);
    });

    /* Filters drawer */
    var panel = root.querySelector('[data-filters-panel]');
    var overlay = root.querySelector('.coll__overlay');
    var opener = root.querySelector('[data-filters-open]');
    function openFilters() {
      if (!panel) return;
      panel.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('has-drawer');
    }
    function closeFilters() {
      if (!panel || !panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('has-drawer');
    }
    if (opener) opener.addEventListener('click', openFilters);
    root.addEventListener('click', function (e) { if (e.target.closest('[data-filters-close]')) closeFilters(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilters(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;
    var form = root.querySelector('[data-pdp-form]');
    var dataEl = document.querySelector('[data-pdp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}

    /* ── Sizes: "2.4m x 1.2m", "1.2m x 600mm", "600mm x 25m" → metres ── */
    function toMetres(part) {
      var m = String(part).trim().toLowerCase().match(/([\d.,]+)\s*(mm|cm|m)?/);
      if (!m) return NaN;
      var n = parseFloat(m[1].replace(',', '.'));
      var unit = m[2] || 'm';
      return unit === 'mm' ? n / 1000 : unit === 'cm' ? n / 100 : n;
    }
    function parseSize(text) {
      if (!text) return null;
      var parts = String(text).split(/\s*[x×]\s*/i);
      if (parts.length < 2) return null;
      var a = toMetres(parts[0]), b = toMetres(parts[1]);
      return (a > 0 && b > 0) ? { a: a, b: b } : null;
    }
    function fmt(n) { return (Math.round(n * 100) / 100).toString(); }

    /* ── Options → variant ── */
    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-pdp-option]').forEach(function (fs, i) {
        var checked = fs.querySelector('input:checked');
        out[i] = checked ? checked.value : null;
      });
      return out;
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function currentVariant() {
      var id = form && form.querySelector('[data-pdp-variant-id]');
      var vid = id ? Number(id.value) : null;
      return variants.find(function (v) { return v.id === vid; }) || variants[0];
    }

    var calc = root.querySelector('[data-fcalc]');
    function unitSize() {
      var idx = calc ? parseInt(calc.dataset.sizeIndex, 10) : -1;
      var v = currentVariant();
      var s = (idx >= 0 && v && v.options) ? parseSize(v.options[idx]) : null;
      return s || (calc ? parseSize(calc.dataset.fallback) : null);
    }

    /* ── Add-ons: tape works itself out from sheets × size; others follow the quantity × ratio ── */
    function addonQty(row, units) {
      if (row.dataset.role === 'tape') {
        var size = unitSize();
        var roll = parseFloat(row.dataset.roll) || 0;
        if (!size || !(roll > 0)) return 1;
        return Math.max(1, Math.ceil(units * (size.a + size.b) / roll));
      }
      var r = parseFloat(row.dataset.ratio);
      if (isNaN(r)) r = 1;
      return r === 0 ? 1 : Math.max(1, Math.ceil(units * r));
    }
    function syncAddons(units) {
      root.querySelectorAll('[data-addon]').forEach(function (row) {
        var q = row.querySelector('[data-addon-qty]');
        if (!q || q.dataset.touched) return;
        q.value = addonQty(row, units);
      });
    }
    root.addEventListener('input', function (e) { if (e.target.matches('[data-addon-qty]')) e.target.dataset.touched = '1'; });
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-addon-on]')) return;
      e.target.closest('[data-addon]').classList.toggle('is-on', e.target.checked);
    });

    /* ── Quantity steppers (buy box and bar share the value) ── */
    function qtyNow() {
      var i = root.querySelector('[data-qty-in]');
      return Math.max(1, parseInt(i && i.value, 10) || 1);
    }
    function syncQty(val) {
      val = Math.max(1, parseInt(val, 10) || 1);
      document.querySelectorAll('[data-qty-in]').forEach(function (i) { if (i.value !== String(val)) i.value = val; });
      syncAddons(val);
      qtyTouched = true;
      highlightBulk();
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn || !btn.closest('[data-pdp], [data-satc]')) return;
      var input = btn.parentElement.querySelector('[data-qty-in]');
      var n = parseInt(input.value, 10) || 1;
      syncQty(btn.dataset.qty === '+' ? n + 1 : n - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('input', function (e) { if (e.target.matches('[data-qty-in]')) syncQty(e.target.value); });
    syncAddons(qtyNow());

    /* ── Money in both VAT modes: the header switch shows one of the two spans, as everywhere else ── */
    var vatF = 1 + (parseFloat(root.dataset.vatRate) || 20) / 100;
    var net = root.dataset.net === 'true';
    var gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
    function money(p) { return gbp.format(Math.round(p) / 100); }
    function both(p) {
      var ex = net ? p : p / vatF, inc = net ? p * vatF : p;
      return '<span data-vat-inc>' + money(inc) + '</span><span data-vat-ex>' + money(ex) + '</span>';
    }
    function pct(n) { return (Math.round(n * 10) / 10) + '%'; }

    /* ── Bulk prices. Tiers come from the table the Hulk app draws for the variant
       shown ("Buy 25 +", "5% Off (£3.13 Each Exc. VAT)"); prices are worked out
       from the variant price, rounded as the app rounds. null = can't read it. ── */
    var bulkWrap = root.querySelector('[data-bulk]');
    var bulkSrc = root.querySelector('[data-bulk-src]');
    var tiers = [];
    var qtyTouched = false;
    function readTiers() {
      var rows = root.querySelectorAll('[data-bulk-src] .hulkapps-table tbody tr');
      var out = [];
      for (var i = 0; i < rows.length; i++) {
        var cells = rows[i].querySelectorAll('td');
        if (cells.length < 2) return null;
        var min = parseInt((cells[0].textContent.match(/\d+/) || [])[0], 10);
        var off = parseFloat((cells[1].textContent.match(/(\d+(?:\.\d+)?)\s*%/) || [])[1]);
        if (!(min > 0) || !(off > 0)) return null;
        out.push({ min: min, pct: off });
      }
      return out.sort(function (a, b) { return a.min - b.min; });
    }
    function tierPrice(t) { var v = currentVariant(); return v ? v.price * (1 - t.pct / 100) : 0; }
    function reachedTier(n) { var r = null; tiers.forEach(function (t) { if (n >= t.min) r = t; }); return r; }
    function nextTier(n) { for (var i = 0; i < tiers.length; i++) { if (tiers[i].min > n) return tiers[i]; } return null; }
    function renderBulk() {
      if (!bulkWrap) return;
      var read = readTiers();
      var ok = !!(read && read.length);
      tiers = ok ? read : [];
      bulkWrap.classList.toggle('is-ours', ok);
      var teaser = root.querySelector('[data-bulk-teaser]');
      if (teaser) teaser.hidden = !ok;
      if (ok) {
        var v = currentVariant();
        var first = tiers[0].min;
        var rows = first > 1 ? '<tr data-min="1"><th scope="row">' + (first > 2 ? '1–' + (first - 1) : '1') + '</th><td>' + both(v.price) + '</td><td></td></tr>' : '';
        tiers.forEach(function (t) {
          rows += '<tr data-min="' + t.min + '"><th scope="row"><button type="button" data-bulk-qty="' + t.min + '" aria-label="Use quantity ' + t.min + '">' + t.min + '+</button></th>' +
            '<td>' + both(tierPrice(t)) + '</td><td><span class="bulkt__save">Save ' + pct(t.pct) + '</span></td></tr>';
        });
        root.querySelector('[data-bulk-rows]').innerHTML = rows;
        root.querySelector('[data-bulk-teaser-text]').innerHTML = 'As low as <b>' + both(tierPrice(tiers[tiers.length - 1])) + '</b> each with bulk prices';
      }
      highlightBulk();
    }
    function highlightBulk() {
      var n = qtyNow();
      var r = reachedTier(n);
      var min = r ? r.min : 1;
      root.querySelectorAll('[data-bulk-rows] tr').forEach(function (tr) { tr.classList.toggle('is-current', Number(tr.dataset.min) === min); });
      var el = root.querySelector('[data-bulk-nudge]');
      if (!el) return;
      var nx = nextTier(n), msg = '';
      if (qtyTouched && tiers.length) {
        if (r) msg = 'Bulk price: <b>' + both(tierPrice(r)) + '</b> each, you save ' + pct(r.pct) + '.';
        if (nx && nx.min - n <= Math.max(5, Math.ceil(n * .25))) msg += (msg ? ' ' : '') + 'Add ' + (nx.min - n) + ' more to save ' + pct(nx.pct) + '.';
      }
      el.querySelector('[data-bulk-nudge-text]').innerHTML = msg;
      el.hidden = !msg;
    }
    root.addEventListener('click', function (e) {
      var row = e.target.closest('[data-bulk-rows] tr');
      var b = e.target.closest('[data-bulk-qty]') || (row && row.querySelector('[data-bulk-qty]'));
      if (!b) return;
      syncQty(b.dataset.bulkQty);
      var input = root.querySelector('[data-qty-in]');
      if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    /* The app (re)draws its table after load and after each variant change */
    if (bulkSrc && 'MutationObserver' in window) {
      var bulkTimer;
      new MutationObserver(function () { clearTimeout(bulkTimer); bulkTimer = setTimeout(renderBulk, 60); })
        .observe(bulkSrc, { childList: true, subtree: true, characterData: true });
    }

    /* ── "How many do I need?" ── */
    if (calc) {
      var lIn = calc.querySelector('[data-fcalc-l]');
      var wIn = calc.querySelector('[data-fcalc-w]');
      var out = calc.querySelector('[data-fcalc-out]');
      var list = calc.querySelector('[data-fcalc-list]');
      var note = calc.querySelector('[data-fcalc-note]');
      var tierEl = calc.querySelector('[data-fcalc-tier]');
      var waste = parseFloat(calc.dataset.waste) || 0;
      var one = calc.dataset.one || 'sheet', many = calc.dataset.many || 'sheets';
      var plan = null;
      function num(input) { return parseFloat(String(input.value).replace(',', '.')); }
      function figure() {
        var L = num(lIn), W = num(wIn);
        var size = unitSize();
        if (!(L > 0) || !(W > 0) || !size) { out.hidden = true; plan = null; return; }
        var area = L * W;
        var unitArea = size.a * size.b;
        var n = Math.max(1, Math.ceil(area * (1 + waste / 100) / unitArea));
        plan = { n: n, area: area, size: size };
        var rows = [[n, n === 1 ? one : many], [fmt(area) + ' m²', 'to cover']];
        var tapeRow = root.querySelector('[data-addon][data-role="tape"]');
        if (tapeRow) {
          plan.tape = addonQty(tapeRow, n);
          rows.splice(1, 0, [plan.tape, plan.tape === 1 ? 'roll of joining tape' : 'rolls of joining tape']);
        }
        list.innerHTML = rows.map(function (r) { return '<li><b>' + r[0] + '</b>' + r[1] + '</li>'; }).join('');
        note.textContent = 'Each ' + one + ' (' + fmt(size.a) + 'm × ' + fmt(size.b) + 'm) covers ' + fmt(unitArea) + ' m². ' +
          (waste > 0 ? 'Includes ' + waste + '% extra for cutting and overlaps. ' : '') +
          (tapeRow ? 'Tape is worked out from the joins between ' + many + '.' : '');
        var reached = reachedTier(n), next = nextTier(n);
        var msg = '';
        if (reached) msg = 'At ' + n + ' ' + many + ' you get the bulk price: ' + both(tierPrice(reached)) + ' each (save ' + pct(reached.pct) + ').';
        if (next && next.min - n <= Math.max(5, Math.ceil(n * .25))) msg += (msg ? ' ' : '') + 'Order ' + next.min + ' to save ' + pct(next.pct) + '.';
        tierEl.innerHTML = msg;
        tierEl.hidden = !msg;
        out.hidden = false;
        var done = calc.querySelector('.fcalc__done');
        if (done) done.remove();
      }
      lIn.addEventListener('input', figure);
      wIn.addEventListener('input', figure);
      root.addEventListener('change', function (e) { if (e.target.closest('[data-pdp-option]') && plan) setTimeout(figure, 0); });
      calc.addEventListener('click', function (e) {
        if (!e.target.closest('[data-fcalc-apply]') || !plan) return;
        syncQty(plan.n);
        root.querySelectorAll('[data-addon][data-role="tape"]').forEach(function (row) {
          var on = row.querySelector('[data-addon-on]');
          var q = row.querySelector('[data-addon-qty]');
          q.value = plan.tape || addonQty(row, plan.n);
          q.dataset.touched = '1';
          on.checked = true;
          row.classList.add('is-on');
        });
        var msg = document.createElement('p');
        msg.className = 'fcalc__done';
        msg.textContent = 'Done: quantities filled in below.';
        out.appendChild(msg);
        var add = root.querySelector('[data-pdp-add]');
        if (add) add.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* ── The promise links open their panel below (the link itself scrolls to it) ── */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-open-acc]');
      if (!a) return;
      var d = document.querySelector(a.getAttribute('href'));
      if (d) d.open = true;
    });

    /* ── Gallery ── */
    var hero = root.querySelector('[data-pdp-hero] img');
    function showMedia(id, full) {
      if (!hero) return;
      var thumbs = root.querySelectorAll('[data-pdp-thumb]');
      var target = null;
      thumbs.forEach(function (t) {
        var match = id ? t.dataset.mediaId === String(id) : t.dataset.full === full;
        t.classList.toggle('is-active', match);
        if (match) target = t;
      });
      var src = (target && target.dataset.full) || full;
      if (src) { hero.src = src; hero.removeAttribute('srcset'); }
    }
    var openZoom = null;
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-pdp-thumb]');
      if (!t) return;
      if (t.dataset.video && openZoom) {
        openZoom(Array.prototype.indexOf.call(root.querySelectorAll('[data-pdp-thumb]'), t));
        return;
      }
      showMedia(null, t.dataset.full);
    });

    /* ── Full-screen viewer: arrows / ← → step, a click on the picture zooms in
       where you clicked (move the mouse to look around), Esc or a click outside closes ── */
    var zoom = document.querySelector('[data-zoom]');
    if (zoom && typeof zoom.showModal === 'function') {
      var stage = zoom.querySelector('[data-zoom-stage]');
      var count = zoom.querySelector('[data-zoom-count]');
      var items = [], at = 0;
      var collect = function () {
        var thumbs = root.querySelectorAll('[data-pdp-thumb]');
        if (thumbs.length) {
          return Array.prototype.map.call(thumbs, function (t) {
            var im = t.querySelector('img');
            return { src: t.dataset.zoomSrc, video: t.dataset.video, kind: t.dataset.videoKind, alt: im ? im.alt : '' };
          });
        }
        var h = root.querySelector('[data-pdp-hero]');
        var hi = h && h.querySelector('img');
        return h && h.dataset.zoomSrc ? [{ src: h.dataset.zoomSrc, alt: hi ? hi.alt : '' }] : [];
      };
      var show = function (i) {
        if (!items.length) return;
        at = (i + items.length) % items.length;
        var it = items[at];
        stage.innerHTML = '';
        if (it.video && it.kind === 'external_video') {
          var fr = document.createElement('iframe');
          fr.src = it.video;
          fr.title = 'Product video';
          fr.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
          fr.allowFullscreen = true;
          fr.className = 'zoom__video';
          stage.appendChild(fr);
        } else if (it.video) {
          var vd = document.createElement('video');
          vd.src = it.video; vd.controls = true; vd.autoplay = true; vd.playsInline = true;
          vd.className = 'zoom__video';
          stage.appendChild(vd);
        } else {
          var frame = document.createElement('span');
          frame.className = 'zoom__frame';
          var img = document.createElement('img');
          img.src = it.src; img.alt = it.alt; img.className = 'zoom__img';
          frame.appendChild(img);
          stage.appendChild(frame);
        }
        count.textContent = items.length > 1 ? (at + 1) + ' / ' + items.length : '';
        zoom.classList.toggle('is-single', items.length < 2);
      };
      var aim = function (e, img) {
        var r = img.parentElement.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      };
      openZoom = function (i) {
        items = collect();
        if (!items.length) return;
        show(i);
        zoom.showModal();
        document.documentElement.classList.add('zoom-open');
      };
      zoom.addEventListener('close', function () { stage.innerHTML = ''; document.documentElement.classList.remove('zoom-open'); });
      root.addEventListener('click', function (e) {
        if (!e.target.closest('[data-zoom-open]')) return;
        var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
        var active = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        openZoom(Math.max(0, active));
      });
      zoom.addEventListener('click', function (e) {
        if (e.target.closest('[data-zoom-close]')) { zoom.close(); return; }
        var step = e.target.closest('[data-zoom-step]');
        if (step) { show(at + Number(step.dataset.zoomStep)); return; }
        var img = e.target.closest('.zoom__img');
        if (img) { aim(e, img); img.classList.toggle('is-zoomed'); return; }
        if (e.target === zoom || e.target === stage) zoom.close();
      });
      zoom.addEventListener('mousemove', function (e) {
        var img = e.target.closest('.zoom__img.is-zoomed');
        if (img) aim(e, img);
      });
      zoom.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') show(at + 1);
        if (e.key === 'ArrowLeft') show(at - 1);
      });
    }

    function reveal(attr, id) {
      document.querySelectorAll('[' + attr + ']').forEach(function (el) {
        el.hidden = el.getAttribute(attr) !== String(id);
      });
    }
    function markAvailability(opts) {
      root.querySelectorAll('[data-pdp-option]').forEach(function (fs, i) {
        fs.querySelectorAll('.pill').forEach(function (pill) {
          var val = pill.querySelector('input').value;
          var test = opts.slice(); test[i] = val;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, j) { return j === i ? o === val : (test[j] == null || o === test[j]); });
          });
          pill.classList.toggle('is-oos', !ok);
        });
        var lbl = fs.querySelector('[data-pdp-optvalue]');
        if (lbl && opts[i]) lbl.textContent = opts[i];
      });
    }
    function setAddState(available) {
      var add = root.querySelector('[data-pdp-add]');
      var bar = document.querySelector('[data-satc-add]');
      [add, bar].forEach(function (b) { if (b) b.disabled = !available; });
      document.querySelectorAll('[data-pdp-addtext]').forEach(function (t) { t.textContent = available ? 'Add to basket' : 'Out of stock'; });
    }
    function applyVariant(v) {
      var idInput = form && form.querySelector('[data-pdp-variant-id]');
      if (!v) { setAddState(false); document.querySelectorAll('[data-pdp-addtext]').forEach(function (t) { t.textContent = 'Unavailable'; }); return; }
      if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      reveal('data-variant-price', v.id);
      reveal('data-variant-ppm', v.id);
      reveal('data-variant-stock', v.id);
      setTimeout(renderBulk, 1500);
      var sku = root.querySelector('[data-pdp-sku]');
      if (sku) { sku.textContent = 'SKU ' + (v.sku || ''); sku.hidden = !v.sku; }
      var pic = v.featured_media;
      if (pic && pic.id) showMedia(pic.id, pic.preview_image && pic.preview_image.src);
      setAddState(v.available);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      syncAddons(qtyNow());
    }
    /* A combination that doesn't exist (e.g. a 4mm small sheet) moves the other
       options to the nearest one that does, so the button never dead-ends */
    function nearest(opts, changed) {
      var exact = findVariant(opts);
      if (exact) return exact;
      var best = null, score = -1;
      variants.forEach(function (v) {
        if (v.options[changed] !== opts[changed]) return;
        var s = v.options.reduce(function (acc, o, i) { return acc + (o === opts[i] ? 1 : 0); }, 0) + (v.available ? .5 : 0);
        if (s > score) { score = s; best = v; }
      });
      return best;
    }
    root.addEventListener('change', function (e) {
      var fs = e.target.closest('[data-pdp-option]');
      if (!fs) return;
      var opts = selectedOptions();
      var changed = parseInt(fs.dataset.pdpOption, 10);
      var v = nearest(opts, changed);
      if (v && !findVariant(opts)) {
        root.querySelectorAll('[data-pdp-option]').forEach(function (f, i) {
          var input = Array.prototype.find.call(f.querySelectorAll('input'), function (x) { return x.value === v.options[i]; });
          if (input) input.checked = true;
        });
        opts = selectedOptions();
      }
      markAvailability(opts);
      applyVariant(v);
    });
    if (root.querySelector('[data-pdp-option]')) markAvailability(selectedOptions());
    renderBulk();

    /* ── Bottom bar ── */
    var satc = document.querySelector('[data-satc]');
    var addBtn = root.querySelector('[data-pdp-add]');
    if (satc && addBtn && 'IntersectionObserver' in window) {
      satc.hidden = false;
      document.body.classList.add('has-satc');
      /* Large screens: the bar appears once the buy box has scrolled away.
         Phones and short laptop screens (under 860px tall): also while the
         button is still below the first screen, so "Add to basket" is always
         one tap away (it adds the variant shown, which opens on the best seller). */
      var phone = window.matchMedia('(max-width: 61.99em), (max-height: 860px)');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && (e.boundingClientRect.top < 0 || phone.matches);
        satc.classList.toggle('is-in', show);
        document.documentElement.classList.toggle('satc-in', show);
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(addBtn);
      var satcAdd = satc.querySelector('[data-satc-add]');
      if (satcAdd && form) satcAdd.addEventListener('click', function () { form.requestSubmit(addBtn); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-recs]');
    if (!el || !el.dataset.url) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recs]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else el.closest('.shopify-section').style.display = 'none';
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-seotext]').forEach(function (sec) {
      var body = sec.querySelector('[data-seotext-body]');
      var btn = sec.querySelector('[data-seotext-more]');
      if (!body || !btn || body.scrollHeight < 200) return;
      sec.classList.add('is-clamped');
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = sec.classList.toggle('is-clamped') === false;
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Show less' : 'Read more';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
